import { signInWithEmailAndPassword } from "firebase/auth";
import { useContext, useState } from "react";
import { auth, db } from "../Firebase";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../DataContext";
import { ref, get } from "firebase/database";
import { toast } from "react-toastify";
const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { setData } = useContext(DataContext);
    const loginHandle = async (e) => {
        e.preventDefault();
        setLoading(true); // Set loading to true
        try {
            const userCredential = await signInWithEmailAndPassword(
                auth,
                email,
                password
            );
            const user = userCredential.user;
            if (user.emailVerified) {
                const userRef = ref(db, user.uid);
                const snapshot = await get(userRef);
                if (snapshot.exists()) {
                    setData(snapshot.val());
                    const userData = snapshot.val();
                    if (userData.height !== 0) {
                        navigate("/");
                    } else {
                        navigate("/data");
                    }
                } else {
                    toast.warn("User data not found.");
                }
            } else {
                await auth.signOut(); // Sign out the user if email is not verified
                toast.warn("Please verify your email before logging in.");
            }
        } catch (error) {
            switch (error.code) {
                case "auth/user-not-found":
                    toast.warn("No user found with this email.");
                    break;
                case "auth/wrong-password":
                    toast.warn("Incorrect password. Please try again.");
                    break;
                case "auth/invalid-credential":
                    toast.warn("Invalid Credentials. Please try again.");
                    break;
                default:
                    toast.error("An error occurred. Please try again.");
            }
        } finally {
            setLoading(false); // Reset loading state
        }
    };
    return (
        <div className="page">
            <h1>Welcome Back</h1>
            <br />
            <input
                type="email"
                placeholder="Enter Email"
                className="info"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />
            <input
                type="password"
                placeholder="Enter Password"
                className="info"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />
            <button
                className="btn"
                onClick={loginHandle}
                disabled={loading} // Disable button while loading
            >
                <b>{loading ? "Logging In..." : "LOG IN"}</b>
            </button>
        </div>
    );
};
export default Login;
